import { render, staticRenderFns } from "./CellTagsContainer.vue?vue&type=template&id=a9aaff68&scoped=true&"
import script from "./CellTagsContainer.vue?vue&type=script&lang=js&"
export * from "./CellTagsContainer.vue?vue&type=script&lang=js&"
import style0 from "./CellTagsContainer.vue?vue&type=style&index=0&id=a9aaff68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9aaff68",
  null
  
)

export default component.exports